var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mini-button',{attrs:{"variant":"light"},on:{"btnClick":_vm.openI18nModal}},[_vm._v("\n        I18n\n    ")]),_c('re-b-modal',{ref:"i18nModal",attrs:{"header":"I18n","fit-content":""}},[_c('mini-table',{attrs:{"read-only":"","effect-origin-row":"","items":_vm.localItems,"fields":_vm.i18nFields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }